// extracted by mini-css-extract-plugin
export default {"table":"Society_table__2SIBH","nomaj":"Society_nomaj__B4QGa","first":"Society_first__4XfGj","edit":"Society_edit__aWIOT","add":"Society_add__drfT8"};